import React from 'react';
import { useNavigate } from 'react-router-dom';
import StateSelector from '../../Admin/TabelaRSL/StateSelector';
import './PrecatorioGroups.css';

const PrecatorioGroups = () => {
  const navigate = useNavigate();

  const handleStateSelect = (state) => {
    navigate(`/associado/precatorio-groups/${state.toLowerCase()}`);
  };

  return (
    <div className="precatorio-groups-container">
      <div className="page-header">
        <h1>Agrupamento de Precatórios</h1>
        <p className="page-description">
          Visualize precatórios agrupados por CPF, CNPJ ou OAB para cada estado
        </p>
      </div>
      
      <div className="info-cards">
        <div className="info-card">
          <div className="info-icon cpf-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z" fill="currentColor"/>
              <path d="M12 14C7.59 14 4 17.59 4 22H20C20 17.59 16.41 14 12 14Z" fill="currentColor"/>
            </svg>
          </div>
          <div className="info-content">
            <h3>Por CPF</h3>
            <p>Agrupa precatórios por pessoa física beneficiária</p>
          </div>
        </div>

        <div className="info-card">
          <div className="info-icon cnpj-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z" fill="currentColor"/>
            </svg>
          </div>
          <div className="info-content">
            <h3>Por CNPJ</h3>
            <p>Agrupa precatórios por pessoa jurídica beneficiária</p>
          </div>
        </div>

        <div className="info-card">
          <div className="info-icon oab-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM7 7H17V5H19V19H5V5H7V7Z" fill="currentColor"/>
              <path d="M12 9L10 11L12 13L14 11L12 9Z" fill="currentColor"/>
              <path d="M7 12H9V17H7V12Z" fill="currentColor"/>
              <path d="M15 12H17V17H15V12Z" fill="currentColor"/>
            </svg>
          </div>
          <div className="info-content">
            <h3>Por OAB</h3>
            <p>Agrupa precatórios por advogado representante</p>
          </div>
        </div>
      </div>

      <StateSelector onStateSelect={handleStateSelect} />
    </div>
  );
};

export default PrecatorioGroups;